import { useDispatch, useSelector } from "react-redux";
import { pusher } from "@common/services/socketCommution";
import { reducerPaths } from "../../../../../app/reducerPaths";
import React from "react";
import { Bidding_Through } from "../../../../../utils/constants/auction";

const useListenForNewLiveAuctionCars = ({
  Vehicle_Id,
  onNewBidHandler,
  onNewCarInAuctionHandler
}) => {

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  // useSelector start...
  const auth = useSelector(store => store[reducerPaths.auth]);
  // useSelector end...

  // Handlers start...
  const newCarInAuctionHandler = (e) => {
    console.log("newCarInAuctionHandler", e);
    if (onNewCarInAuctionHandler) {
      onNewCarInAuctionHandler(e?.vehicle);
    }
  };
  // Handlers end...

  // useEffect start...
  React.useEffect(() => {
    const channel = pusher.subscribe(`dealers`);
    channel.bind(`auction.started`, newCarInAuctionHandler);

    return () => {
      channel.unbind(`auction.started`, newCarInAuctionHandler);
    }
  }, []);
  // useEffect end...
};  

export {
  useListenForNewLiveAuctionCars
};